import FormLayout from './FormLayout';
import FormItem from './FormItem';
import FormRow from './FormRow';

FormLayout.FormRow = FormRow;
FormLayout.FormItem = FormItem;

export default FormLayout;


// WEBPACK FOOTER //
// ./src/index.js